export enum UserContentColorHex {
    Blue = '#0099CC',
    Brown = '#7F4F04',
    DarkBlue = '#0055FF',
    DarkGreen = '#009900',
    Gold = '#FFCC00',
    Gray = '#777B82',
    Green = '#26C407',
    Orange = '#FF7E00',
    Purple = '#9900CC',
    Red = '#CC0000',
    Salmon = '#FF6666',
}
